import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { DateRangePicker } from '@calendly/ui/components/date-range-picker';
import { useClose } from '@calendly/ui/components/dropdown';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useRef, useState, forwardRef } from 'react';
import { Bookmarks } from './bookmarks';
const buildRangeFromAnchor = (anchor, next) => anchor <= next ? [anchor, next] : [next, anchor];
const controlButtonIsTabletUpCss = "c1x0sbdx";
const controlButtonCss = "c1f2mdc8";
const ControlButton = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <Button ref={ref} {...props} className={classNames(controlButtonCss, {
    [controlButtonIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const footerIsTabletUpCss = "fbq5e8p";
const footerCss = "f1mi8528";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const Picker = ({
  startDate,
  endDate,
  timezone,
  onChange,
  period,
  isMIPage
}) => {
  const [currentStartDate, setCurrentStartDate] = useState(startDate);
  const [currentEndDate, setCurrentEndDate] = useState(endDate);
  const closePicker = useClose();
  // RangeCalendar sets start === end on the first click; wait for the second before applying.
  const rangeSelectionStartedRef = useRef(false);
  const rangeAnchorDateRef = useRef(null);
  const applyFixedRange = (rangeStart, rangeEnd) => {
    rangeSelectionStartedRef.current = false;
    rangeAnchorDateRef.current = null;
    setCurrentStartDate(rangeStart);
    setCurrentEndDate(rangeEnd);
    onChange({
      period: 'fixed',
      startDate: rangeStart,
      endDate: rangeEnd
    });
    closePicker();
  };
  const handleChange = ([start, end]) => {
    if (isMIPage) {
      if (start !== end) {
        applyFixedRange(start, end);
        return;
      }
      if (!rangeSelectionStartedRef.current) {
        rangeSelectionStartedRef.current = true;
        rangeAnchorDateRef.current = start;
        setCurrentStartDate(start);
        setCurrentEndDate(end);
        return;
      }
      const anchor = rangeAnchorDateRef.current;
      if (start === anchor) {
        applyFixedRange(start, end);
        return;
      }
      const [rangeStart, rangeEnd] = buildRangeFromAnchor(anchor, start);
      applyFixedRange(rangeStart, rangeEnd);
      return;
    }
    setCurrentStartDate(start);
    setCurrentEndDate(end);
  };
  const onSave = () => {
    onChange({
      period: 'fixed',
      startDate: currentStartDate,
      endDate: currentEndDate
    });
    closePicker();
  };
  return <>
      <Bookmarks isMIPage={isMIPage} period={period} onChange={onChange} />
      <DateRangePicker timezone={timezone} startDate={currentStartDate} endDate={currentEndDate} onChange={handleChange} />
      {!isMIPage && <Footer>
        <ControlButton onClick={closePicker} decoration="ghost">
          {I18n.t('publisher.action.cancel')}
        </ControlButton>
        <ControlButton onClick={onSave} disabled={!currentStartDate || !currentEndDate}>
          {I18n.t('publisher.action.apply')}
        </ControlButton>
      </Footer>}
    </>;
};

require("./picker.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./picker.js");